import ChosenThemeContext from '@/contexts/styles/ChosenThemeContext';
import ChosenThemeSizeContext from '@/contexts/styles/ChosenThemeSizeContext';
import ThemeActionContext, { IThemeCreationOptions } from '@/contexts/styles/ThemeActionContext';
import DefaultThemeOptions from '@/styles/DefaultThemeOptions';
import { CssBaseline, ThemeProvider as MuiThemeProvider, ThemeOptions, createTheme } from '@mui/material';
import { FC, PropsWithChildren, useContext, useMemo, useState } from 'react';


export interface IThemeContextProps extends IThemeCreationOptions {
}


export const ThemeProvider: FC<PropsWithChildren<IThemeContextProps>> = ({
    afterThemeCreated,
    themeOptions,
    beforeThemeCreated, 
    children 
}) => {
    const theme = useContext(ChosenThemeContext);
    const themeSize = useContext(ChosenThemeSizeContext);

    const [ themeCreationOptions, setThemeCreationOptions ] = useState<IThemeCreationOptions>(() => ({ themeOptions, beforeThemeCreated, afterThemeCreated }))

    const muiTheme = useMemo(() => {
        let options: ThemeOptions = !!themeCreationOptions.themeOptions ? 
            {
                ...themeCreationOptions.themeOptions,
                palette: {
                    ...themeCreationOptions.themeOptions.palette,
                    mode: theme ?? 'light',
                }
            } :
            {
                ...DefaultThemeOptions,
                palette: {
                    ...DefaultThemeOptions.palette,
                    mode: theme ?? 'light',
                }
            };

        // Update MUI Theme Options using event function if provided.
        if (themeCreationOptions.beforeThemeCreated) {
            options = themeCreationOptions.beforeThemeCreated(options, theme ?? 'light', themeSize ?? 'medium');
        }

        // Create MUI Theme from MUI Theme Options.
        let t = createTheme(options);

        // Update MUI Theme using event function if provided.
        if (themeCreationOptions.afterThemeCreated) {
            t = themeCreationOptions.afterThemeCreated(t, theme ?? 'light', themeSize ?? 'medium');
        }

        return t;
    }, [theme, themeSize, themeCreationOptions]);

    const actionContext = useMemo(() => {
        return {
            setThemeCreationOptions
        }
    }, [setThemeCreationOptions])

    return (
        <ThemeActionContext.Provider value={actionContext}>
            <MuiThemeProvider theme={muiTheme}>
                <CssBaseline enableColorScheme />
                {children}
            </MuiThemeProvider>
        </ThemeActionContext.Provider>
    );
}

export default ThemeProvider;
